import React from "react";
// colors
import { Colors } from '_styles';

const TableHeader = (props) => {

    return (
        <div style={{ width: props.width }}>
            <p style={{ fontSize: 14, opacity: 0.6, fontWeight: 'bold', textAlign: props.align ? props.align : props.title == 'Assistance' ? 'center' : 'left', color: Colors.TEXT_COLOR }}>{props.title}</p>
        </div>
    );
}

export default TableHeader;